import styled from "styled-components";

export default styled.div`
  display: flex;
  position: relative;
  font-size: 16px;
  width: 100%;
  margin: 1.6rem 0 1.5rem;
  line-height: 1.5rem;
  color: ${(props) => (props.error ? "#fe5144" : "#09100F")};

  ${(props) => props.thisStyles}
`;
